/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFeaturedInWithLogosCf052Fragment, FeaturedInWithLogosCf052Fragment, FullFeaturedInWithLogosCf052Fragment} from '@amblique/contentful/app/contentful/fragments/featured-in-with-logos-cf052';

/**
 * Get a single FeaturedInWithLogosCf052 by ID (base - scalars only)
 */
export const getBaseFeaturedInWithLogosCf052ById = gql`
  ${BaseFeaturedInWithLogosCf052Fragment}

  query GetBaseFeaturedInWithLogosCf052ById($id: String!, $locale: String!, $preview: Boolean) {
    featuredInWithLogosCf052(id: $id, locale: $locale, preview: $preview) {
      ...BaseFeaturedInWithLogosCf052Fragment
    }
  }
`;

/**
 * Get a single FeaturedInWithLogosCf052 by ID (standard - 1 level deep)
 */
export const getFeaturedInWithLogosCf052ById = gql`
  ${FeaturedInWithLogosCf052Fragment}

  query GetFeaturedInWithLogosCf052ById($id: String!, $locale: String!, $preview: Boolean) {
    featuredInWithLogosCf052(id: $id, locale: $locale, preview: $preview) {
      ...FeaturedInWithLogosCf052Fragment
    }
  }
`;

/**
 * Get a single FeaturedInWithLogosCf052 by ID (full - 2 levels deep)
 */
export const getFullFeaturedInWithLogosCf052ById = gql`
  ${FullFeaturedInWithLogosCf052Fragment}

  query GetFullFeaturedInWithLogosCf052ById($id: String!, $locale: String!, $preview: Boolean) {
    featuredInWithLogosCf052(id: $id, locale: $locale, preview: $preview) {
      ...FullFeaturedInWithLogosCf052Fragment
    }
  }
`;

/**
 * Get all FeaturedInWithLogosCf052 entries with pagination (base - scalars only)
 */
export const getBaseFeaturedInWithLogosCf052s = gql`
  ${BaseFeaturedInWithLogosCf052Fragment}

  query GetBaseFeaturedInWithLogosCf052s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeaturedInWithLogosCf052Order]
    $where: FeaturedInWithLogosCf052Filter
    $preview: Boolean
  ) {
    featuredInWithLogosCf052Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseFeaturedInWithLogosCf052Fragment
      }
    }
  }
`;

/**
 * Get all FeaturedInWithLogosCf052 entries with pagination (standard - 1 level deep)
 */
export const getFeaturedInWithLogosCf052s = gql`
  ${FeaturedInWithLogosCf052Fragment}

  query GetFeaturedInWithLogosCf052s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeaturedInWithLogosCf052Order]
    $where: FeaturedInWithLogosCf052Filter
    $preview: Boolean
  ) {
    featuredInWithLogosCf052Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FeaturedInWithLogosCf052Fragment
      }
    }
  }
`;

/**
 * Get all FeaturedInWithLogosCf052 entries with pagination (full - 2 levels deep)
 */
export const getFullFeaturedInWithLogosCf052s = gql`
  ${FullFeaturedInWithLogosCf052Fragment}

  query GetFullFeaturedInWithLogosCf052s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeaturedInWithLogosCf052Order]
    $where: FeaturedInWithLogosCf052Filter
    $preview: Boolean
  ) {
    featuredInWithLogosCf052Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullFeaturedInWithLogosCf052Fragment
      }
    }
  }
`;
